import { Controller } from "@hotwired/stimulus"

// Generic click-to-toggle controller
// Toggles visibility of content and optionally rotates an icon
export default class extends Controller {
  static targets = ["content", "icon"]
  static values = { contentSelector: String, iconSelector: String }

  toggle(event) {
    const content = this.findContent()
    const icon = this.findIcon(event)

    if (content) {
      content.classList.toggle("hidden")
    }

    if (icon) {
      icon.classList.toggle("up")
      icon.classList.toggle("down")
    }
  }

  findContent() {
    if (this.hasContentTarget) {
      return this.contentTarget
    }

    return this.element.nextElementSibling
  }

  findIcon(event) {
    if (this.hasIconTarget) {
      return this.iconTarget
    }

    return event.currentTarget.querySelector(".caret")
  }
}
